"use client"

import { useState, useEffect, useRef } from "react"
import DOMPurify from "dompurify"
import MarkdownIt from "markdown-it"
import Spinner from "../Spinner"
import TurndownService from 'turndown'
const turndownService = new TurndownService()
// h1〜h6を # 形式で出力
turndownService.addRule('customHeading', {
  filter: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  replacement: function (content, node) {
    const hLevel = Number(node.nodeName.charAt(1));  // h1 -> 1, h2 -> 2
    return `${'#'.repeat(hLevel)} ${content}\n\n`
  }
})

// liタグは "- " にする
turndownService.addRule('customListItem', {
  filter: 'li',
  replacement: function (content) {
    return `- ${content.trim()}\n`
  }
})

const mdParser = new MarkdownIt()

const Outline = ({ outline = "", showOutlineProcessing = false, onEdit }) => {
  const [numberedOutline, setNumberedOutline] = useState("")
  const [isEditing, setIsEditing] = useState(false)
  const editableRef = useRef(null)

  useEffect(() => {
    const numberOutline = (text) => {
      if (!text) return ""

      const lines = text.split("\n")
      const numbering = [0, 0, 0]
      const result = []

      lines.forEach((line) => {
        if (line.startsWith("# ")) {
          // タイトルは番号を付けない
          result.push(line)
        } else if (line.startsWith("## ")) {
          numbering[0]++
          numbering[1] = 0
          numbering[2] = 0
          result.push(`## ${numbering[0]}. ${line.substring(3)}`)
        } else if (line.startsWith("### ")) {
          numbering[1]++
          numbering[2] = 0
          result.push(`### ${numbering[0]}-${numbering[1]}. ${line.substring(4)}`)
        } else if (line.startsWith("#### ")) {
          numbering[2]++
          result.push(`#### ${numbering[0]}-${numbering[1]}-${numbering[2]}. ${line.substring(5)}`)
        } else {
          result.push(line)
        }
      })

      return result.join("\n")
    }

    setNumberedOutline(numberOutline(outline))
  }, [outline])

  const renderMarkdown = (text) => {
    return mdParser.render(text)
  }

  const handleBlur = () => {
    setIsEditing(false)
    if (editableRef.current) {
      const html = editableRef.current.innerHTML
      const markdown = turndownService.turndown(html)
      // 正規表現で「### 数字-数字. 」などを「### 」に置換
      let cleanedMarkdown = markdown.replace(/(#+)\s+\d+(-\d+)*\.\s+/g, '$1 ')
      cleanedMarkdown = cleanedMarkdown.replace(/^(#+)\s+\d+\\\.\s+/gm, '$1 ')

      onEdit(cleanedMarkdown)
    }
  }
  
  return (
    <div className="document-outline h-full overflow-y-auto w-full">
      {showOutlineProcessing && <Spinner />}
      <div
        ref={editableRef}
        contentEditable={true}
        suppressContentEditableWarning={true}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(renderMarkdown(numberedOutline)) }}
        onFocus={() => setIsEditing(true)}
        onBlur={() => handleBlur()}
        className={`p-3 rounded-md min-h-[100px] transition-all ${isEditing ? "outline-editing" : ""}`}
      />
    </div>
  )
}

export default Outline
